@if (entity$ | async; as entity) {
  @if (params$ | async; as params) {
    @if (mainTabsSupport$ | async; as mainTabsSupport) {
      <div class="header">
        <div class="header__left">
          @if (mainTabsSupport.backButton) {
            <a class="cursor-pointer" (click)="goToHome()">
              <ts-icon icon="arrow_back"></ts-icon>
            </a>
          }
          {{ entity$ | async | jupiterFaceValue: (relatedTo$ | async) : (context$ | async) }}
        </div>
        <div class="header__center">
          @if (mainTabsSupport.details && firstTabId$ | async; as firstTabId) {
            <a
              (click)="goToFirstTab(params, firstTabId)"
              [class.active]="{ active: activeMainTab | async, target: 'tab' } | tsMutateToAny: isActive"
              >Details</a
            >
          }
          @if (mainTabsSupport.financials) {
            <a
              routerLink="./asset-management"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onExternalModuleLinkClick()"
              >Financials</a
            >
          }
          @if (mainTabsSupport.files) {
            <a
              routerLink="./folders"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onExternalModuleLinkClick()"
              >Files
              @if (entity.num_documents > 0) {
                <ts-badge [value]="entity.num_documents" type="info" floating="true"></ts-badge>
              }
            </a>
          }
          @if (mainTabsSupport.notes) {
            <a
              routerLink="./notes"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onExternalModuleLinkClick()"
              >Notes
              @if (entity.num_notes > 0) {
                <ts-badge [value]="entity.num_notes" type="info" floating="true"></ts-badge>
              }
            </a>
          }
          @if (mainTabsSupport.tasks) {
            <a
              [routerLink]="'./tasks/' + (taskTabPrefix$ | async) + '/' + params.recordId"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onExternalModuleLinkClick()"
              >Tasks
              @if (entity.num_open_tasks > 0) {
                <ts-badge [value]="entity.num_open_tasks" type="info" floating="true"></ts-badge>
              }
            </a>
          }
          @if (mainTabsSupport.activities) {
            <a
              routerLink="./activities"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onExternalModuleLinkClick()"
              >Activities</a
            >
          }
          @if (mainTabsSupport.engagements) {
            <a
              routerLink="./engagements"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onExternalModuleLinkClick()"
              >Engagements</a
            >
          }
          @if (mainTabsSupport.crmTasks) {
            <a
              routerLink="./crm-tasks"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onExternalModuleLinkClick()"
              >CRM Tasks</a
            >
          }

          @if (mainTabsSupport.leases) {
            <a
              routerLink="./leases"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onExternalModuleLinkClick()"
              >Leases</a
            >
          }
          @if (mainTabsSupport.deals) {
            <a
              routerLink="./deals"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onExternalModuleLinkClick()"
              >Deals</a
            >
          }
          @if (mainTabsSupport.nearby) {
            <a
              routerLink="./nearby"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onExternalModuleLinkClick()"
              >Nearby</a
            >
          }
          @if (mainTabsSupport.contacts) {
            <a
              routerLink="./contacts"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onExternalModuleLinkClick()"
              >Contacts</a
            >
          }
          @if (mainTabsSupport.dispositions) {
            <a
              routerLink="./dispositions"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onExternalModuleLinkClick()"
              >Dispositions</a
            >
          }
          @if (mainTabsSupport.loanQuotes) {
            <a
              routerLink="./loans"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onExternalModuleLinkClick()"
              >Loan Quotes</a
            >
          }
          @if (mainTabsSupport.linkedObjects) {
            @for (linkedObject of linkedObjects$ | async; track $index) {
              <a
                (click)="onLinkedObjectClick(linkedObject)"
                [class.active]="
                  { active: activeMainTab | async, target: linkedObject.uiConfig.urlPrefix } | tsMutateToAny: isActive
                "
                >{{ linkedObject.label_plural }}</a
              >
            }
          }
        </div>
        <div class="header__right">
          @if (isBusy$ | async) {
            <img class="blink-image" src="/assets/images/logo/ts-logo.png" style="height: auto; width: 32px" />
          }
          @if (mainTabsSupport.contextMenu.enabled) {
            <button class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu">
              <mat-icon [svgIcon]="'more_vert'"></mat-icon>
            </button>
          }
          <mat-menu #moreMenu="matMenu">
            @if (mainTabsSupport.contextMenu.actions.layoutManager) {
              <button
                mat-menu-item
                (click)="toLayoutManager()"
                [appAuthorize]="PermissionSlot.MANAGE_LAYOUT | jupiterPermissionSlot"
                denyAction="disable"
              >
                <mat-icon>dashboard</mat-icon>
                Layout Manager
              </button>
            }
            @if (mainTabsSupport.contextMenu.actions.changeLayout) {
              <button
                mat-menu-item
                (click)="changeLayout()"
                [appAuthorize]="PermissionSlot.MANAGE_LAYOUT | jupiterPermissionSlot"
                denyAction="disable"
              >
                <mat-icon svgIcon="sync_alt"></mat-icon>
                Change Layout
              </button>
            }
            @if (mainTabsSupport.contextMenu.actions.duplicate) {
              <button
                mat-menu-item
                (click)="duplicate()"
                [appAuthorize]="PermissionSlot.CREATE | jupiterPermissionSlot"
                denyAction="disable"
              >
                <mat-icon svgIcon="difference"></mat-icon>
                Duplicate
              </button>
            }
            @if (mainTabsSupport.contextMenu.actions.generateMergeDocument) {
              <button mat-menu-item (click)="generateMergeDocument()">
                <mat-icon svgIcon="description"></mat-icon>
                Generate Merge Document
              </button>
            }
            @if (mainTabsSupport.contextMenu.actions.delete) {
              <button
                mat-menu-item
                (click)="delete()"
                [appAuthorize]="PermissionSlot.DELETE | jupiterPermissionSlot"
                denyAction="disable"
              >
                <mat-icon svgIcon="delete"></mat-icon>
                Delete
              </button>
            }
          </mat-menu>
        </div>
      </div>
    }
  }
}
